import { render, staticRenderFns } from "./g-email.vue?vue&type=template&id=368fed42"
import script from "./g-email.vue?vue&type=script&lang=js"
export * from "./g-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports